import React from 'react';

const formatDateTime = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';

  return date.toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

function FactionBlockedState({
  title,
  description,
  autoBlocked = false,
  currentShow = null,
  blockedAt = null,
  stats = [],
  className = '',
}) {
  const icon = autoBlocked ? 'bi-broadcast-pin' : 'bi-lock';
  const eyebrow = autoBlocked ? 'Blocco show' : 'Scambi disattivati';
  const showBackground = currentShow?.sfondo || currentShow?.backgroundImage || currentShow?.background || '';
  const showLogo = currentShow?.logo || '';
  const stateClassName = [
    'faction-blocked-state',
    showBackground ? 'faction-blocked-state--show' : '',
    className,
  ].filter(Boolean).join(' ');
  const stateStyle = showBackground
    ? {
        backgroundImage: [
          'linear-gradient(135deg, rgba(10, 14, 20, 0.84), rgba(10, 14, 20, 0.62))',
          `url(${showBackground})`,
        ].join(', '),
      }
    : undefined;
  const metaItems = [
    currentShow?.nome
      ? { label: 'Show in corso', value: currentShow.nome }
      : null,
    currentShow?.endTime
      ? { label: 'Riapertura', value: formatDateTime(currentShow.endTime) }
      : null,
    !autoBlocked && blockedAt
      ? { label: 'Blocco attivo dal', value: blockedAt.toLocaleString('it-IT') }
      : null,
  ].filter(Boolean);

  return (
    <section
      className={stateClassName}
      style={stateStyle}
    >
      <div className="faction-blocked-state__main">
        <div className="faction-blocked-state__icon" aria-hidden="true">
          {showLogo ? (
            <img src={showLogo} alt="" className="faction-blocked-state__logo" />
          ) : (
            <i className={`bi ${icon}`} />
          )}
        </div>

        <div className="faction-blocked-state__copy">
          <span className="faction-blocked-state__eyebrow">{eyebrow}</span>
          <h3 className="brand-title mb-2">{title}</h3>
          <p className="text-muted-brand mb-0">{description}</p>
        </div>
      </div>

      {metaItems.length > 0 && (
        <div className="faction-blocked-state__meta">
          {metaItems.map((item) => (
            <div key={item.label} className="faction-blocked-state__meta-item">
              <span>{item.label}</span>
              <strong>{item.value}</strong>
            </div>
          ))}
        </div>
      )}

      {stats.length > 0 && (
        <div className="faction-blocked-state__stats">
          {stats.map((item) => (
            <div key={item.label} className="faction-blocked-state__stat">
              <span>{item.label}</span>
              <strong>{item.value}</strong>
              {item.helper && <small>{item.helper}</small>}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default FactionBlockedState;
